module.exports = __webpack_public_path__ + "static/RECEPTOR-aee8e6b2c1c720b2bb743b5a696c5478.svg";